import { graphql } from 'react-apollo';

import { AllClaims } from '../../queries/AllClaims';
import { paginationVariables } from '../../utils/pagination';

const withClaimsListQuery = graphql(AllClaims, {
  options: ({ filter, ...rest }) => {
    return {
      variables: {
        filter: {
          ...filter,
          active: true
        },
        ...paginationVariables(rest)
      },
      notifyOnNetworkStatusChange: true
    };
  },
  props: ({
    data: { claimsConnection, variables, loading, error },
    filters
  }) => ({
    error,
    loading,
    claimsConnection,
    variables,
    filters
  })
});

export default WrappedComponent => withClaimsListQuery(WrappedComponent);



// WEBPACK FOOTER //
// ./src/component/ClaimsListPage/withClaimsListQuery.js